import { render, staticRenderFns } from "./GestionBodega.vue?vue&type=template&id=8d8ca094&scoped=true"
import script from "./GestionBodega.vue?vue&type=script&lang=js"
export * from "./GestionBodega.vue?vue&type=script&lang=js"
import style0 from "./GestionBodega.vue?vue&type=style&index=0&id=8d8ca094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8ca094",
  null
  
)

export default component.exports